import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import fullstory from '../../../../utils/constants/fullstory'
import sendFullStoryEvent from '../../../../utils/analyticsHelpers/sendFullStoryEvent'

const DISABLED_OPACITY = 0.3

class LeftDrawerNavLink extends Component {
  static propTypes = {
    content: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    history: PropTypes.any.isRequired,
    path: PropTypes.string.isRequired,
    location: PropTypes.any.isRequired,
    icon: PropTypes.any,
  }

  render() {
    const { content, disabled, history, label, location, path, icon } = this.props

    const isActive = path === location.pathname

    return (
      <div
        onClick={() => {
          if (content === 'Personality') {
            sendFullStoryEvent(fullstory.eventNames.personalityAssessmentClick)
          }
        }}
      >
        <button
          disabled={disabled}
          id={`left-drawer-nav-link-${content}`}
          className="btn"
          style={{
            width: '100%',
            textAlign: 'left',
            paddingRight: 0,
            paddingLeft: 15,
          }}
          onClick={() => history.push(path)}
        >
          <span
            style={{
              color: isActive ? '#5099de' : '#4a5f70',
              letterSpacing: 0,
              opacity: disabled ? DISABLED_OPACITY : 1,
              fontWeight: isActive ? '600' : '400',
              fontSize: '16px',
              marginBottom: 10,
            }}
          >
            <img
              src={icon}
              alt=""
              style={{
                filter: 'invert(67%)',
                padding: '0',
                marginTop: -5,
                width: '100%',
                maxHeight: 25,
                maxWidth: 25,
                height: 'auto',
                objectFit: 'contain',
                objectPosition: 'center',
                marginRight: 15,
              }}
            />
            {label ? label.replace('-', ' ') : content.replace('-', ' ')}
          </span>
        </button>
        {(content === 'Admin-Home' || content === 'Parent-Home') && (
          <div style={{ margin: '7px' }} />
        )}
      </div>
    )
  }
}

export default withRouter(LeftDrawerNavLink)



// WEBPACK FOOTER //
// ./src/components/ui/drawer/components/LeftDrawerNavLink.js